<button (click)="onToggled()" [class]="stateClassNames">
  @if (toggled) {
    {{toggledText || text || ''}}
  }
  @if (!toggled) {
    {{notToggledText || text || ''}}
  }
  <ng-content select="[aza-rws-toggle-button-content]"></ng-content>
  @if (toggled) {
    <ng-content select="[aza-rws-toggle-button-toggled-state-content]"></ng-content>
  }
  @if (!toggled) {
    <ng-content select="[aza-rws-toggle-button-not-toggled-state-content]"></ng-content>
  }
</button>
